import React from 'react';
import { useRouter } from 'next/router';
import CompactLayout from '@strongio/pretrained-dashboard/layouts/CompactLayout';

export default function ExternalServiceErrorView({ onClose }) {
  const router = useRouter();

  const {
    error, code: errorCode, utm_source: utmSource, utm_medium: utmMedium } =
  router.query;

  return /*#__PURE__*/(
    React.createElement(CompactLayout, { title: "Aw, Snap!" }, /*#__PURE__*/
    React.createElement("p", { className: "text-gray-600" }, "Something went wrong, while performing the requested operation."), /*#__PURE__*/



    React.createElement("pre", { className: "mt-4 text-gray-600 whitespace-pre-wrap text-sm" },
    errorCode ? `${errorCode}: ` : '',
    error), /*#__PURE__*/


    React.createElement("div", { className: "text-gray-400 text-xs" }, "Source:",

    ' ',
    utmSource, ", Medium:",

    ' ',
    utmMedium), /*#__PURE__*/


    React.createElement("div", { className: "mt-4" }, /*#__PURE__*/
    React.createElement("button", {
      type: "button",
      onClick: onClose,
      className: "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-500 hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" }, "Close"))));






}